import { gql } from '@apollo/client';

export const GET_REPORT_SECONDARY_USERS_LIST = gql`
  query reportSecondaryUsersList($organizationId: ID!, $adAccountIds: [ID!]!, $excludeSellers: Boolean) {
    getReportSecondaryUsersList(
      organizationId: $organizationId
      adAccountIds: $adAccountIds
      excludeSellers: $excludeSellers
    ) {
      id
      email
      firstName
      lastName
      createdAt
      lastLoginAt
      updatedAt
      entityType
    }
  }
`;
